import React, { Component } from 'react';
import { Widget, toggleMsgLoader, stopMsgLoader, toggleWidget, isWidgetOpened, renderCustomComponent } from 'react-chat-widget';
// eslint-disable-next-line no-unused-vars
import ChatSession from 'amazon-connect-chatjs'; //Provides connect variable

import CustomStyler from './CustomStyler.js';
import ChatMessage from './ChatMessage.js';

import 'react-chat-widget/lib/styles.css';

// import ic_button from '../assets/ic_button.svg';

const chat_statuses = {
  STARTING: "starting",
  ACTIVE: "active"
};

const start_types = {
  AUTO: "auto",
  MANUAL: "manual",
  TIMED: "timed"
};

const container = {
  show: () => {
    window.parent.postMessage('showChatWindow', '*')
  },
  hide: () => {
    window.parent.postMessage('hideChatWindow', '*')
  }
};

class ChatWidget extends Component {
  constructor(props) {
    console.log(props)
    super(props);
    this.state = {
      // style: null,
      // typing: false,
      chatStatus: null
    };
  };

  // eslint-disable-next-line no-undef
  chatSession;

  messageQueue = [];

  componentDidMount() {
    window.addEventListener("beforeunload", this.beforeUnload);
    //Start with the container sized for the launcher
    container.hide();
    //Toggle based on widget params
    this.customToggle();
    renderCustomComponent(ChatMessage, {
      message: this.props.options.init_message || "Hello! Thank you for contacting us. How may we help you?",
      role: "AGENT"
    });
  };

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.beforeUnload)
  };

  customToggle = () => {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      //Mobile, so leave as manual instead of auto or timed load
    }else{
      switch (this.props.options.start_type) {
        case start_types.AUTO:
          toggleWidget();
          container.show()
          break;
        case start_types.MANUAL:
          break;
        case start_types.TIMED:
          if(this.props.options.autoload_wait_seconds) {
            setTimeout(() => {
              if(!isWidgetOpened()) {
                toggleWidget();
                container.show();
              }
            }, (this.props.options.autoload_wait_seconds || 5) * 1000)
          };
          break;
        default:
          break;
      }
    }
  };

  beforeUnload = () => {
    this.chatSession && this.chatSession.disconnectParticipant();
  }

  /********************************************
  *
  *          Chat Widget Events
  *
  *  These are triggered by the widget
  *
  **********************************************/

  //This is triggered by the widget when the user enters a message
  handleNewUserMessage = async (newMessage) => {
    console.log(`New message incoming: ${newMessage}`);
    if(this.state.chatStatus === chat_statuses.ACTIVE) {
      this.sendMessage(newMessage);
    } else if(this.state.chatStatus === chat_statuses.STARTING) {
      this.messageQueue.push(newMessage);
    } else {
      this.messageQueue.push(newMessage);
      this.setState({ chatStatus: chat_statuses.STARTING });
      await this.startChat();
      this.messageQueue.forEach(m=>this.sendMessage(m));
    }
  };

  //Triggered when the widget is toggled, but only from a user click
  //Even if toggleWidget() starts to trigger this handler, this will
  //still work because we are checking the open status before doing anything
  // ** THIS IS A CUSTOM EVENT, NOT IN THE STOCK NPM PACKAGE **
  handleToggle = async (isOpened) => {
    // console.log("widget toggled, isOpened?", isOpened);
    if (isOpened) {
      container.show();
    } else {
      container.hide();
    }
  };

  //This is triggered by the widget when the user types
  handleTextInputChange = async (e) => {
    // console.log('handleTextInputChange: ', e)
    //Send a typing event to connect
    if(this.state.chatStatus === chat_statuses.ACTIVE) {
      this.chatSession.sendEvent({
        contentType: "application/vnd.amazonaws.connect.event.typing"
      })
    }
  }

  startChat = async () => {
    // console.log("starting chat");
    const logger = {
      debug: (data) => {console.debug(data);},
      info: (data) => {console.info(data);},
      warn: (data) => {console.warn(data);},
      error: (data) => {console.error(data);}
    }

    const globalConfig = {
      loggerConfig: {
        logger: logger,
        // There are four levels available - DEBUG, INFO, WARN, ERROR. Default is INFO.
        // eslint-disable-next-line no-undef
        level: connect.ChatSession.LogLevel.INFO,
      },
      region: "us-east-1" // "us-west-2" is the default value.
    };

    // eslint-disable-next-line no-undef
    connect.ChatSession.setGlobalConfig(globalConfig);

    // This might default the DisplayName to something, or get something
    // from a form that was there previously
    let body = {
      Attributes: {
        chat_referrer: document.referrer,
        widgetId: this.props.options.widgetId
      },
      ParticipantDetails: {
        // DisplayName: "Mike"
      }
    }

    const response = await fetch("/start", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });
    console.log(response)
    const json = await response.json();
    console.log(json);

    let chatParams = {
      chatDetails: json.data.startChatResult,
      // eslint-disable-next-line no-undef
      type: connect.ChatSession.SessionTypes.CUSTOMER
    };

    // eslint-disable-next-line no-undef
    this.chatSession = await connect.ChatSession.create(chatParams);

    await this.chatSession.connect().then((response) => {
      console.log("successful connection: " + JSON.stringify(response));
      this.setState({ chatStatus: chat_statuses.ACTIVE });
      return Promise.resolve(response);
    }, (error) => {
      console.log("unsuccessful connection " + JSON.stringify(error));
      return Promise.reject(error);
    });

    this.subscribeToChatEvents(this.chatSession);
  };

  subscribeToChatEvents = (session) => {
    //These are events coming from the AWS Connect chat session
    console.log(session);
    session.onConnectionBroken(this.handleChatConnectionBroken);
    session.onTyping(this.handleChatTyping);
    session.onMessage(this.handleChatMessage);
    session.onConnectionEstablished(this.handleChatConnectionEstablished);
    session.onEnded(this.handleChatEnded);
  };

  /********************************************
  *
  *          Connect Chat Session Events
  *
  *  These are triggered by the AWS Connect chat session
  *
  **********************************************/

  handleChatConnectionBroken = (data) => {
    console.log("Connection broken", data);
  };

  handleChatTyping = (typingEvent) => {
    console.log("Typing...", typingEvent);
    // Connect sends start and end events, but this gets tripped
    // up when the agent sends the message before the typing end
    // event.  Ideally it could be set to "off" when a message comes in
    // but we only have a toggle function
    if(typingEvent.data.ParticipantRole === 'AGENT') {
      toggleMsgLoader();
    } //Otherwise we don't really care, just confirmation that we sent

  };

  //When an external message comes in
  handleChatMessage = (message) => {
    console.log("Received message: " + JSON.stringify(message.data));
    console.log(message.data.Type)
    stopMsgLoader();
    if(message.data.Type === "MESSAGE") {
      renderCustomComponent(ChatMessage, {
        message: message.data.Content,
        role: message.data.ParticipantRole
      })
    }
  };

  handleChatConnectionEstablished = (data) => {
    console.log("Connection established", data);
  };

  handleChatEnded = () => {
    console.log("Chat ended");
  };

  sendMessage = (message) => {
    console.log(message)
    this.chatSession.sendMessage({
      message: message,
      contentType: "text/plain"
    })
  }

  render() {
    return (
      <>
        <CustomStyler color={this.props.options.color}>
          <Widget
            handleNewUserMessage={this.handleNewUserMessage}
            handleTextInputChange={this.handleTextInputChange}
            handleToggle={this.handleToggle}
            title={this.props.options.title || "Live Chat"}
            subtitle={null}
          />
        </CustomStyler>
      </>
    )
  };
};

export default ChatWidget;
